import { render, staticRenderFns } from "./QuickSave.vue?vue&type=template&id=00c5f926&"
import script from "./QuickSave.vue?vue&type=script&lang=js&"
export * from "./QuickSave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports